import { Typography } from 'components';
import { EmptyClipArt } from 'lib/svgs/ClipArts';
import { useTranslations } from 'next-intl';

const EmptyInvoice = () => {
  const t = useTranslations();
  return (
    <div className="flex w-full flex-col items-center justify-center">
      <EmptyClipArt />
      <Typography variant="regular3" className="!m-0 text-tertiary-200">
        {t('billing.no_preview')}
      </Typography>
    </div>
  );
};

export default EmptyInvoice;
